import { clayName } from './ClayIcon';

/** CSS clay stand-ins; each one swaps to the exported icon in public/icons/clay/ once it exists. */

function ClayImg({ name, size, className = '' }) {
  return (
    <img
      src={`/icons/clay/${size <= 72 ? 'sm/' : ''}${name}.webp`}
      alt=""
      width={size}
      height={size}
      decoding="async"
      draggable="false"
      className={`clay-icon squish ${className}`}
      style={{ width: size, height: size }}
    />
  );
}

export function Parcel({ className = '', size = 150 }) {
  if (clayName('parcel')) return <ClayImg name="parcel" size={size} className={className} />;
  const h = Math.round(size * 0.87);
  return (
    <div className={`clay squish ${className}`} style={{ position: 'relative', width: size, height: h, borderRadius: 30, background: '#F2B66B' }}>
      <div className="clay-in" style={{ position: 'absolute', left: size * 0.41, top: 0, width: size * 0.17, height: h, background: '#E3963A' }} />
      <div className="clay-soft" style={{ position: 'absolute', left: size * 0.15, top: h * 0.26, width: 34, height: 34, borderRadius: 10, background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <svg width="18" height="18" viewBox="0 0 20 20" aria-hidden="true">
          <rect x="7" y="2" width="6" height="16" rx="1.5" fill="#E5484D" />
          <rect x="2" y="7" width="16" height="6" rx="1.5" fill="#E5484D" />
        </svg>
      </div>
    </div>
  );
}

export function MapPin({ size = 84 }) {
  if (clayName('pin')) return <ClayImg name="pin" size={size} />;
  return (
    <div className="clay" style={{ position: 'relative', width: size, height: size, borderRadius: '50% 50% 50% 0', transform: 'rotate(-45deg)', background: '#FFB547' }}>
      <div className="clay-in" style={{ position: 'absolute', left: size * 0.3, top: size * 0.3, width: size * 0.4, height: size * 0.4, borderRadius: '50%', background: '#FFF4E0' }} />
    </div>
  );
}

export function Coin({ size = 86 }) {
  if (clayName('coin')) return <ClayImg name="coin" size={size} />;
  return (
    <div className="clay squish" style={{ width: size, height: size, borderRadius: '50%', background: '#FFC75A', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div className="clay-in fw-display" style={{ width: size * 0.7, height: size * 0.7, borderRadius: '50%', background: '#FFD27A', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 800, fontSize: size * 0.35, color: '#8A5A00' }}>
        ₹
      </div>
    </div>
  );
}

export function Scooter() {
  if (clayName('scooter')) return <ClayImg name="scooter" size={170} />;
  return (
    <div className="squish" style={{ position: 'relative', width: 190, height: 130 }}>
      <div className="clay" style={{ position: 'absolute', left: 30, top: 30, width: 130, height: 60, borderRadius: '40px 50px 30px 30px', background: '#3462F2' }} />
      <div className="clay-soft" style={{ position: 'absolute', left: 112, top: 4, width: 22, height: 44, borderRadius: 12, background: '#2A3A6E', transform: 'rotate(18deg)' }} />
      <div className="clay-soft" style={{ position: 'absolute', left: 48, top: 16, width: 56, height: 22, borderRadius: 14, background: '#2A3A6E' }} />
      <div className="clay" style={{ position: 'absolute', left: 0, top: 2, width: 54, height: 46, borderRadius: 14, background: '#F2B66B' }} />
      <div className="clay" style={{ position: 'absolute', left: 24, top: 74, width: 48, height: 48, borderRadius: '50%', background: '#2A3046' }} />
      <div className="clay-in" style={{ position: 'absolute', left: 39, top: 89, width: 18, height: 18, borderRadius: '50%', background: '#C9CFDF' }} />
      <div className="clay" style={{ position: 'absolute', left: 124, top: 74, width: 48, height: 48, borderRadius: '50%', background: '#2A3046' }} />
      <div className="clay-in" style={{ position: 'absolute', left: 139, top: 89, width: 18, height: 18, borderRadius: '50%', background: '#C9CFDF' }} />
    </div>
  );
}

export function Pills() {
  if (clayName('pill')) return <ClayImg name="pill" size={150} />;
  return <div className="clay" style={{ width: 170, height: 64, borderRadius: 999, transform: 'rotate(-28deg)', background: 'linear-gradient(90deg, #3462F2 0 50%, #F6F8FD 50% 100%)' }} />;
}

export function Phone() {
  if (clayName('phone')) return <ClayImg name="phone" size={160} />;
  return (
    <div className="clay squish" style={{ position: 'relative', width: 96, height: 172, borderRadius: 26, background: '#3462F2', transform: 'rotate(-8deg)' }}>
      <div className="clay-in" style={{ position: 'absolute', left: 10, top: 14, width: 76, height: 132, borderRadius: 16, background: '#EAF0FF', padding: '10px 8px', boxSizing: 'border-box', display: 'flex', flexDirection: 'column', gap: 6 }}>
        <div style={{ height: 40, borderRadius: 8, background: '#D6E1FF' }} />
        <div style={{ height: 10, borderRadius: 4, background: '#C6D4FB' }} />
        <div style={{ height: 10, borderRadius: 4, background: '#C6D4FB' }} />
        <div style={{ height: 14, borderRadius: 6, background: '#FFB547', marginTop: 'auto' }} />
      </div>
    </div>
  );
}

export function Clipboard() {
  if (clayName('clipboard')) return <ClayImg name="clipboard" size={100} />;
  return (
    <div className="clay squish" style={{ position: 'relative', width: 70, height: 90, borderRadius: 18, background: '#F6F8FD' }}>
      <div className="clay-soft" style={{ position: 'absolute', left: 20, top: -8, width: 30, height: 16, borderRadius: 8, background: '#3462F2' }} />
      <div style={{ position: 'absolute', left: 14, top: 28, width: 42, height: 6, borderRadius: 3, background: '#C6D4FB' }} />
      <div style={{ position: 'absolute', left: 14, top: 42, width: 34, height: 6, borderRadius: 3, background: '#C6D4FB' }} />
      <div style={{ position: 'absolute', left: 14, top: 56, width: 38, height: 6, borderRadius: 3, background: '#C6D4FB' }} />
    </div>
  );
}

export function Shop() {
  if (clayName('shop')) return <ClayImg name="shop" size={100} />;
  return (
    <div className="clay squish" style={{ position: 'relative', width: 96, height: 78, borderRadius: 20, background: '#1FBF7A' }}>
      <div className="clay-soft" style={{ position: 'absolute', left: -6, top: -14, width: 108, height: 24, borderRadius: 12, background: '#17A066' }} />
      <div className="clay-soft" style={{ position: 'absolute', left: 33, top: 26, width: 30, height: 30, borderRadius: 10, background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <svg width="16" height="16" viewBox="0 0 20 20" aria-hidden="true">
          <rect x="7" y="2" width="6" height="16" rx="1.5" fill="#1FBF7A" />
          <rect x="2" y="7" width="16" height="6" rx="1.5" fill="#1FBF7A" />
        </svg>
      </div>
    </div>
  );
}

/** Brand whistle; only renders once the clay export exists. */
export function Whistle({ size = 110 }) {
  return clayName('whistle') ? <ClayImg name="whistle" size={size} /> : null;
}

export function ArrowIcon() {
  return (
    <svg className="btn-arrow" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" aria-hidden="true">
      <path d="M5 12h14M13 6l6 6-6 6" />
    </svg>
  );
}
